{
  "greeting": {
    "salam": "Esselamu alejkum",
    "salamWithName": "Esselamu alejkum, {{name}}"
  },
  "dock": {
    "saved": "Të ruajtura",
    "savedVerses": "Ajetet e ruajtura",
    "tasks": "Detyrat",
    "notes": "Shënimet"
  },
  "actions": {
    "save": "Ruaj",
    "cancel": "Anulo",
    "close": "Mbyll",
    "delete": "Fshij",
    "rename": "Riemërto",
    "dismiss": "Hiq",
    "loading": "Duke ngarkuar…",
    "reload": "Ringarko",
    "retry": "Riprovo",
    "expand": "Zgjero",
    "collapse": "Palos"
  },
  "nav": {
    "appNavigation_aria": "Navigimi i aplikacionit"
  },
  "tabs": {
    "home": "Kreu",
    "tasks": "Detyrat",
    "notes": "Shënimet",
    "more": "Më shumë"
  },
  "more": {
    "daily": "Ditore",
    "account": "Llogaria",
    "savedVerses": "Vargjet e ruajtura",
    "qibla": "Kibla",
    "prayerTimes": "Oraret e faljes dhe kujtuesit",
    "rhemnPro": "Rhemn Pro",
    "proManagedViaAccount": "Menaxhohet përmes llogarisë suaj Rhemn",
    "upgrade": "Përmirëso",
    "privacyPolicy": "Politika e privatësisë",
    "version": "Rhemn · v{{version}}",
    "back_aria": "Prapa",
    "deleteAccount": "Fshij llogarinë"
  },
  "reflection": {
    "dismiss_aria": "Hiq reflektimin"
  },
  "app": {
    "loading_aria": "Rhemn po ngarkohet",
    "logo_alt": "Rhemn",
    "safariManageOnWeb": "Menaxho abonimin tënd Rhemn Pro në web. Pro zhbllokohet automatikisht këtu kur kyçesh me llogarinë tënde të abonuar."
  },
  "header": {
    "qiblaDirection_aria": "Drejtimi i Qiblas",
    "prayerTimes_aria": "Oraret e namazit",
    "prayerTimesTitle": "Oraret e Namazit",
    "method": "Metoda",
    "methodHelp": "Metoda ndikon në oraret e llogaritura"
  },
  "search": {
    "search_aria": "Kërko",
    "searchLabel": "Kërko",
    "searchWeb_placeholder": "Kërko në web"
  },
  "focus": {
    "input_placeholder": "Çfarë ka rëndësi më shumë sot?",
    "example_worship": "Të falem me përkushtim, pa nxitim",
    "example_kindness": "Ta marr nënën në telefon vetëm për ta dëgjuar",
    "example_reflect": "Reflekto mbi qëllimin me ajetin e sotëm",
    "saveIntention_aria": "Ruaj qëllimin",
    "celebration": "🤲 Mashalla"
  },
  "profile": {
    "profileFallback": "Profili",
    "profileAndAccount_aria": "Profili dhe llogaria",
    "profileDialog_aria": "Profili",
    "editName_aria": "Ndrysho emrin tënd",
    "logo_alt": "Rehmn",
    "proBadge": "PRO",
    "manageSubscription": "Menaxho abonimin",
    "manageSubscription_aria": "Menaxho abonimin tënd Rehmn Pro",
    "anonymousAnalytics": "Analitika anonime",
    "anonymousAnalyticsNote": "Vetëm të grumbulluara — kurrë të lidhura me ty",
    "shareAnalytics_aria": "Shpërndaj analitikën anonime të përdorimit",
    "signOut": "Çkyçu",
    "signingOut": "Duke u çkyçur…",
    "signOut_aria": "Çkyçu nga Rehmn",
    "restorePurchases": "Restore purchases",
    "restorePurchases_aria": "Restore previous purchases"
  },
  "background": {
    "loading": "Duke ngarkuar sfondin...",
    "fallbackNotice": "Duke përdorur imazhin rezervë (Unsplash API i padisponueshëm)",
    "noImage": "Asnjë imazh sfondi i disponueshëm",
    "error": "Gabim: {{message}}",
    "photoByOnUnsplash": "Foto nga <photographer>{{name}}</photographer> në <unsplash>Unsplash</unsplash>"
  },
  "error": {
    "title": "Diçka shkoi keq",
    "fallbackMessage": "Ndodhi një gabim i papritur."
  },
  "theme": {
    "switchToLight_title": "Kalo në modalitetin e ndritshëm",
    "switchToDark_title": "Kalo në modalitetin e errët"
  },
  "upgradeCta": {
    "upgradeToPro": "Përmirëso në Pro",
    "restorePurchases": "Restore purchases",
    "restoring": "Restoring…",
    "restoreEmpty": "No purchases found.",
    "pricePerMonth": "{{price}} / muaj",
    "pricePerYear": "{{price}} / vit",
    "purchasePending": "Në pritje të miratimit. Pro aktivizohet automatikisht sapo blerja të miratohet.",
    "storeUnavailable": "App Store nuk është i arritshëm për momentin. Provo sërish pas pak.",
    "purchaseFailed": "Blerja nuk u përfundua. Provo sërish pas pak."
  },
  "upgradeCard": {
    "eyebrow": "Rhemn Pro · 25% zbritje për vitin e parë",
    "title": "Për orët mes namazeve të tua.",
    "body": "Shënime zanore që transkriptohen, përmblidhen dhe bëhen detyra. Një planifikues dite i ndërtuar rreth kohëve të namazit. Shënime me AI.",
    "price": "$29.99",
    "period": "për vitin e parë",
    "priceIos": "25% zbritje për vitin e parë",
    "terms": "Më pas $39.99 në vit. Kodi {{code}} u aplikua për ty.",
    "termsIos": "Rinovohet me çmimin e zakonshëm vjetor. Përdor kodin {{code}} në App Store.",
    "free": "Kohët e namazit, Kibla, ajeti i ditës dhe detyrat mbeten falas.",
    "cta": "Përmirëso në Pro",
    "dismiss": "Jo tani"
  },
  "planChooser": {
    "monthly": "Mujore",
    "yearly": "Vjetore",
    "yearlyValue": "Katër muaj dhuratë nga ne.",
    "freeNote": "Oraret e namazit, Kibla, ajeti i ditës dhe detyrat janë falas. Rhemn Pro shton:",
    "includes_planner": "Një ditë e ndërtuar rreth pesë namazeve, dhe “Planifiko ditën time”",
    "includes_insights": "Quran Insights — pyet për çdo ajet dhe lexo kontekstin e tij",
    "includes_reflections": "Reflektime mbi ajetin e ditës, shkruar për nijetin që ke vendosur",
    "includes_notes": "Shënime dhe shënime zanore, me përmbledhje e rregullim me AI",
    "includes_extras": "Ajete të ruajtura, karta ajetesh, seri ditësh dhe parashikim 5-ditor",
    "renewsMonthly": "Rinovohet çdo muaj derisa ta anulosh",
    "renewsYearly": "Rinovohet çdo 12 muaj derisa ta anulosh",
    "continue": "Vazhdo",
    "renewalTerms": "Pagesa i ngarkohet Apple ID-së tënde në momentin e konfirmimit. Abonimi rinovohet automatikisht nëse rinovimi automatik nuk çaktivizohet të paktën 24 orë para përfundimit të periudhës. Menaxho ose anulo në çdo kohë te cilësimet e Apple ID.",
    "retry": "Provo sërish"
  },
  "streak": {
    "badge_aria": "Vazhdimësia ditore — {{count}} ditë",
    "title": "Vazhdimësia ditore",
    "daysWithCount": "Vazhdimësi {{count}}-ditore",
    "start": "Fillo sot — kalo një çast me ajetin ose shëno një namaz.",
    "prayedToday": "U fala sot",
    "readVerse": "Lexova ajetin e sotëm",
    "autoHint": "Ajeti shënohet vetë kur kalon një çast me të.",
    "milestoneTitle": "{{count}} ditë me nijet",
    "milestoneBody": "Elhamdulilah. Ndaje këtë arritje — dikush që e do mund të fillojë gjithashtu.",
    "share": "Ndaj",
    "dismiss": "Jo tani",
    "cardLabel": "ditë me nijet",
    "shareCaption": "{{count}} ditë duke filluar me nijet — rhemn.com",
    "imageSaved": "Imazhi u ruajt.",
    "couldNotCreateImage": "Nuk u krijua dot imazhi. Provo sërish."
  },
  "qibla": {
    "compassIcon_aria": "Ikona e busullës",
    "title": "Drejtimi i Qiblas",
    "locationUnavailable": "Vendndodhja e padisponueshme",
    "locating": "Duke gjetur vendndodhjen…",
    "compass_aria": "Busulla e Qiblas",
    "directionN": "V",
    "directionE": "L",
    "directionS": "J",
    "directionW": "P",
    "facingQibla": "Përballë Qiblas",
    "enableLiveCompass": "Aktivizo Busullën Live",
    "enableLiveCompassNote": "Përdor sensorin e lëvizjes që shigjeta të ndjekë lëvizjet e tua — jo vendndodhjen",
    "directionToMecca": "Drejtimi drejt Mekës",
    "enableLocation": "Aktivizo qasjen në vendndodhje për të llogaritur drejtimin",
    "hintLive": "Shigjeta ndjek orientimin e pajisjes sate në kohë reale",
    "hintStatic": "Kah nga Veriu — përdore me një busull për drejtim të saktë",
    "live": "Live",
    "footerVerse": "\"Andaj, ktheje fytyrën tënde nga Xhamia e Shenjtë\" – Kurani 2:144"
  },
  "legal": {
    "links_aria": "Ligjore",
    "termsOfUse": "Kushtet e përdorimit",
    "privacyPolicy": "Politika e privatësisë"
  },
  "auth": {
    "signInForPro": "Hyni fillimisht — Pro juaj ju ndjek kudo."
  },
  "integrations": {
    "row": {
      "label": "Kalendarë dhe detyra",
      "caption": "I lidhur",
      "subNone": "I palidhur",
      "subFree": "Google Calendar, Google Tasks dhe më shumë",
      "subAttention": "{{provider}} kërkon vëmendje",
      "subPaused": "Sinkronizimi në pauzë"
    },
    "list": {
      "title": "Kalendarë dhe detyra",
      "subtitle": "Sill takimet dhe detyrat e tua në ditën tënde.",
      "footnote": "Rhemn lexon vetëm atë që i nevojitet dhe kurrë nuk ruan ngjarjet e tua.",
      "privacy": "Politika e privatësisë",
      "connect": "Lidhu",
      "connect_aria": "Lidhu me {{what}}",
      "checking": "Duke kontrolluar…",
      "loadError": "Nuk u ngarkuan dot lidhjet e tua.",
      "tryAgain": "Provo sërish",
      "offline": "Je offline. Lidhu kur të kthehesh online.",
      "unavailable": "Kalendarët dhe detyrat nuk janë të disponueshme për momentin.",
      "disconnected": "{{provider}} u shkëput.",
      "google": {
        "name": "Google",
        "sub": "Calendar dhe Tasks",
        "what": "Google Calendar dhe Tasks"
      },
      "todoist": {
        "name": "Todoist",
        "sub": "Detyra dhe projekte",
        "what": "Todoist"
      },
      "apple": {
        "name": "Kalendari dhe Kujtuesit",
        "subNative": "Në këtë {{device}}",
        "subSafari": "Në aplikacionin Rhemn për iPhone dhe Mac"
      },
      "synced": "U sinkronizua {{when}}",
      "connectedSub": "I lidhur",
      "syncing": "Duke sinkronizuar…",
      "reconnectSub": "Rilidhu për të vazhduar sinkronizimin",
      "errorSub": "Sinkronizimi i fundit nuk përfundoi",
      "pausedSub": "Në pauzë · Rhemn Pro përfundoi"
    },
    "explainer": {
      "google": {
        "title": "Lidh Google Calendar dhe Tasks",
        "p1Lead": "Kalendari yt, vetëm për lexim",
        "p1Body": "Rhemn shfaq ngjarjet e tua në ditën tënde dhe sheh kur je i zënë. Nuk i ruan ato.",
        "p2Lead": "Google Tasks, në të dy drejtimet",
        "p2Body": "Listat që zgjedh mbeten të sinkronizuara, kështu që mund t'i shënosh të kryera kudo.",
        "p3Lead": "E ke ty ta zhbësh",
        "p3Body": "Shkëputu kur të duash, këtu ose në Llogarinë tënde Google.",
        "footnote": "Google do të tregojë saktësisht se çfarë po kërkon Rhemn."
      },
      "todoist": {
        "title": "Lidh Todoist",
        "p1Lead": "Projektet e tua, në të dy drejtimet",
        "p1Body": "Projektet që zgjedh mbeten të sinkronizuara, kështu që mund t'i shënosh të kryera kudo.",
        "p2Lead": "Si përputhen",
        "p2Body": "Përparësitë e Todoist bëhen Kritike, E lartë, Mesatare dhe E ulët. Nën-detyrat më të thella se një nivel shfaqen si hapa nën detyrën kryesore.",
        "p3Lead": "E ke ty ta zhbësh",
        "p3Body": "Shkëputu kur të duash, këtu ose te cilësimet e Todoist.",
        "cta": "Vazhdo te Todoist",
        "footnote": "Todoist do të kërkojë ta konfirmosh."
      },
      "skip": "Jo tani",
      "cancel": "Anulo",
      "waiting": "Duke pritur për {{provider}}…",
      "safariWaiting": "Përfundo në skedën e re, pastaj kthehu këtu.",
      "safariReopen": "Hap skedën përsëri",
      "denied": "{{provider}} nuk dha qasje, ndaj nuk u lidh asgjë.",
      "error": "Nuk u lidh dot me {{provider}}. Provo sërish pas pak."
    },
    "detail": {
      "back_aria": "Kthehu te Kalendarë dhe detyra",
      "syncNow": "Sinkronizo tani",
      "intro": "Zgjidh çfarë sinkronizon Rhemn. Mund ta ndryshosh kur të duash.",
      "taskLists": "Lista detyrash",
      "projects": "Projekte",
      "reminders": "Kujtuesit",
      "calendars": "Kalendarë",
      "rhemnCalendarSub": "Oraret e tua të namazit nuk numërohen si i zënë",
      "loading": "Duke ngarkuar…",
      "loadError": "Nuk u ngarkuan dot listat e tua.",
      "emptyGoogle": "Nuk ka lista detyrash në Google Tasks.",
      "emptyTodoist": "Nuk ka projekte në Todoist.",
      "addError": "Nuk u shtua dot {{name}}. Provo sërish.",
      "removed": "U hoq nga Rhemn. Ende gjendet në {{provider}}.",
      "undo": "Zhbëj",
      "prayerTimes": "Shto oraret e namazit në kalendarin tënd",
      "prayerTimesSub": "Shton pesë namazet në një kalendar të quajtur Rhemn, për 7 ditët e ardhshme, që të mos rezervohet mbi to.",
      "prayerTimesOn": "Aktiv. Shtuar deri më {{date}}.",
      "prayerTimesWaiting": "Duke pritur për Google…",
      "prayerTimesDenied": "Google nuk e lejoi. Nuk u shtua asgjë.",
      "prayerTimesRemoveAsk": "Të hiqen oraret e namazit të Rhemn nga kalendari yt?",
      "prayerTimesKeep": "Mbaji",
      "prayerTimesRemove": "Hiqi",
      "meetingPrompts": "Sugjerime takimesh",
      "meetingPromptsSub": "Kur një takim me një lidhje po fillon, ofron të marrë shënime.",
      "busyFootnote": "\"Planifiko ditën time\" sheh vetëm kur je i zënë, kurrë çfarë janë takimet e tua.",
      "todoistFootnote": "Përparësitë e Todoist bëhen Kritike, E lartë, Mesatare dhe E ulët. Nën-detyrat më të thella se një nivel shfaqen si hapa nën detyrën kryesore.",
      "reauth": "{{provider}} ndaloi t'i lejojë Rhemn të sinkronizojë. Kjo ndodh kur hiqet qasja ose ndryshon fjalëkalimi yt.",
      "reconnect": "Rilidhu",
      "paused": "Sinkronizimi është në pauzë sepse Rhemn Pro përfundoi. Listat e tua mbeten siç ishin.",
      "calendarDenied": "Qasja te kalendari është e çaktivizuar.",
      "remindersDenied": "Qasja te kujtuesit është e çaktivizuar.",
      "disconnect": "Shkëput {{provider}}",
      "disconnectTitle": "Të shkëputet {{provider}}?",
      "disconnectBody": "Asgjë nuk fshihet në {{provider}}.",
      "disconnectRhemnCal": "Kalendari yt me oraret e namazit të Rhemn do të hiqet nga Google Calendar.",
      "disconnectError": "Nuk u shkëput dot {{provider}}. Provo sërish pas pak.",
      "keepLists": "Mbaji listat e mia në Rhemn",
      "keepListsSub": "Ndalojnë së sinkronizuari dhe bëhen lista të zakonshme të Rhemn.",
      "removeLists": "Hiqi ato nga Rhemn",
      "removeListsSub": "Hiqen vetëm kopjet në Rhemn.",
      "disconnecting": "Duke u shkëputur…",
      "appleStop": "Ndalo përdorimin e Kalendarit dhe Kujtuesve",
      "appleStopTitle": "Të ndalohet përdorimi i Kalendarit dhe Kujtuesve?",
      "appleStopBody": "Rhemn ndalon së shfaquri ngjarjet dhe kujtuesit e tu. Për ta hequr plotësisht qasjen e tij, çaktivizoje te Cilësimet.",
      "justNow": "sapo tani",
      "tasksScope": "Rhemn ka nevojë për leje për të parë Google Tasks-in tënd. Rilidhu dhe shëno Detyrat për ta lejuar.",
      "calendarsLoadError": "Nuk u ngarkuan dot kalendarët e tu.",
      "calendarsEmpty": "Nuk ka kalendarë në këtë llogari.",
      "calendarsScope": "Rhemn ka nevojë për leje për të parë Google Calendar-in tënd. Rilidhu dhe shëno Calendar për ta lejuar.",
      "prayerTimesError": "Nuk u shtuan dot oraret e namazit. Provo sërish pas pak.",
      "remindersEmpty": "Nuk ka lista te Kujtuesit.",
      "openSettings": "Hap Cilësimet",
      "appleStopCta": "Ndalo përdorimin"
    },
    "locked": {
      "body": "Shiko takimet e tua brenda blloqeve të tua të namazit dhe mbaji Google Tasks të sinkronizuara me Rhemn.",
      "googleName": "Google Calendar dhe Tasks"
    },
    "device": {
      "phone": "iPhone",
      "pad": "iPad",
      "mac": "Mac",
      "fallback": "pajisje"
    },
    "tasks": {
      "syncedWith_aria": "{{list}}, sinkronizuar me {{provider}}",
      "unlinkConfirm": "Të hiqet “{{name}}” nga Rhemn? Do të mbetet në {{provider}}.",
      "remove": "Hiqe",
      "offline": "Jashtë linje · Ndryshimet do të sinkronizohen me {{provider}} kur të kthehesh.",
      "stillSyncing": "Ende duke sinkronizuar me {{provider}}…",
      "failed_one": "{{count}} ndryshim nuk arriti te {{provider}}.",
      "failed_other": "{{count}} ndryshime nuk arritën te {{provider}}.",
      "retry": "Provo sërish",
      "needsReconnect": "{{provider}} kërkon që të rilidhesh.",
      "paused": "Sinkronizimi është në pauzë · Rhemn Pro përfundoi.",
      "upgrade": "Përmirëso",
      "notSynced": "Pa sinkronizuar",
      "notSynced_aria": "Nuk është sinkronizuar me {{provider}}. Provo sërish.",
      "remindersOff": "Rhemn nuk mund të arrijë te Kujtuesit. Aktivizoje sërish te Cilësimet.",
      "dueToday": "Sot",
      "dueTomorrow": "Nesër",
      "googleTasks": "Google Tasks"
    },
    "today": {
      "allDay": "Gjithë ditën",
      "more": "+{{count}}",
      "more_aria": "Shfaq edhe {{count}} ngjarje të gjithë ditës",
      "less_aria": "Shfaq më pak ngjarje të gjithë ditës",
      "events_aria": "Ngjarjet",
      "event_aria": "{{start}} deri në {{end}}, {{title}}",
      "allDayEvent_aria": "Gjithë ditën, {{title}}",
      "untitled": "I zënë",
      "now": "Tani · deri në {{end}}",
      "until": "deri në {{end}}",
      "into": "· deri në {{prayer}}",
      "loadError": "Nuk u ngarkua dot kalendari yt.",
      "needsReconnect": "Google Calendar kërkon që të rilidhesh.",
      "scope": "Rhemn nuk e sheh dot Google Calendar-in tënd. Rilidhu dhe shëno Calendar për ta lejuar.",
      "appleOff": "Rhemn nuk e sheh dot kalendarin tënd. Aktivizoje sërish te Cilësimet."
    },
    "plan": {
      "mostlyMeetings": "Kryesisht takime · {{duration}} të lira",
      "noFreeTime": "Pa kohë të lirë",
      "aroundMeetings_one": "U planifikua rreth {{count}} takimi.",
      "aroundMeetings_other": "U planifikua rreth {{count}} takimeve.",
      "settledBusy": "Gjithçka tashmë përshtatet rreth takimeve të tua."
    },
    "meeting": {
      "group_aria": "Takimi po fillon",
      "now": "tani",
      "takeNotes": "Mbaj shënime",
      "takeNotes_aria": "Mbaj shënime për {{title}}",
      "dismiss_aria": "Mbyll",
      "announce": "{{title}} fillon {{when}}.",
      "announceNow": "{{title}} po fillon tani.",
      "yourMeeting": "Takimi yt"
    },
    "apple": {
      "primer": {
        "title": "Shfaq kalendarin pranë namazeve të tua",
        "body": "Rhemn lexon ngjarjet dhe kujtuesit në këtë {{device}} për t'i vendosur në ditën tënde. Ato mbeten në pajisjen tënde. Planifiko ditën time përdor vetëm oraret kur je i zënë.",
        "cta": "Vazhdo",
        "skip": "Jo tani",
        "footnote": "{{device}} do të pyesë dy herë, një herë për Kalendarin dhe një herë për Kujtuesit. Mund t'i ndryshosh të dyja te Cilësimet."
      }
    }
  }
}
